var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboadlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2493 10.5V14.6667C10.2493 15.3571 10.809 15.9167 11.4993 15.9167H15.666C16.3564 15.9167 16.916 15.3571 16.916 14.6667V10.5C16.916 9.80968 16.3564 9.25004 15.666 9.25004H11.4993C10.809 9.25004 10.2493 9.80968 10.2493 10.5Z",
    fill: "#6C737F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19191 9.58449L1.00047 11.7759C0.554531 12.2219 0.554531 12.9449 1.00047 13.3908L3.19191 15.5823C3.63785 16.0282 4.36085 16.0282 4.80679 15.5823L6.99823 13.3908C7.44417 12.9449 7.44417 12.2219 6.99823 11.7759L4.80679 9.58449C4.36085 9.13855 3.63784 9.13856 3.19191 9.58449Z",
    fill: "#6C737F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08268 1.33337L1.08268 5.50004C1.08268 6.1904 1.64233 6.75004 2.33268 6.75004H6.49935C7.1897 6.75004 7.74935 6.1904 7.74935 5.50004V1.33337C7.74935 0.643018 7.1897 0.083374 6.49935 0.083374L2.33268 0.0833742C1.64233 0.0833742 1.08268 0.643018 1.08268 1.33337Z",
    fill: "#6C737F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5827 6.75004C15.4236 6.75004 16.916 5.25766 16.916 3.41671C16.916 1.57576 15.4236 0.083374 13.5827 0.0833741C11.7417 0.0833742 10.2493 1.57576 10.2493 3.41671C10.2493 5.25766 11.7417 6.75004 13.5827 6.75004Z",
    fill: "#6C737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboadlogo);
export default __webpack_public_path__ + "static/media/dashboadlogo.af1569c513634b7d071271c781023bb5.svg";
export { ForwardRef as ReactComponent };